<template>
  <article class="slide">
    <figure class="figure">
      <Box
        :startAnimation="intialized"
        :percentage="percentage"
      >
        <countTo
          ref="counter"
          :startVal="0"
          :endVal="percentage"
          :duration="1000"
          :decimals="0"
          :autoplay="false"
          :suffix="'%'"
        />
      </Box>
      <component :is="icon" />
    </figure>
    <h3 class="title">{{ category }}</h3>
  </article>
</template>

<script>
import Box from './Box'
import countTo from 'vue-count-to'

export default {
  name: 'Slide',
  data () {
    return {
      intialized: false
    }
  },
  components: {
    Box,
    countTo
  },
  props: {
    icon: {
      required: true
    },
    category: {
      type: String,
      required: true
    },
    percentage: {
      type: Number,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkActive () {
      if (this.active && !this.intialized) {
        this.$refs.counter.start()
        this.intialized = true
      }
    }
  },
  mounted () {
    this.checkActive()
  },
  watch: {
    active () {
      this.checkActive()
    }
  }
}
</script>

<style lang="scss" scoped>
.slide {
  margin: 0 20px;
  display: block;
  will-change: opacity, transform;
  width: 212px;
  transition: all 1000ms ease;
  transition-property: opacity, transform;
  opacity: 0.5;
}

.figure {
  margin: 0;
}

.title {
  font-size: $fs-h3;
  margin: 1em 0 0;
  text-align: center;
}
</style>
